import type Phaser from "phaser";

/**
 * Press Start 2P — это битмап-шрифт, дизайнерская сетка 8×8 px на глиф,
 * кратные размеры (8/16/24) рисуются пиксель-в-пиксель. Любой другой
 * размер уходит в субпиксельный rescale и теряет «8-bit» вид.
 *
 * resolution=1 здесь специально: текст рисуется в нативном размере
 * базовой канвы (480×270), а Phaser pixelArt:true уже даёт честный
 * nearest-neighbor scaling на финальный экран. Любое resolution > 1
 * включает сглаживание Canvas API и портит пиксели.
 */
export const TEXT_RESOLUTION = 1;

const FONT = '"Press Start 2P", monospace';

type Style = Phaser.Types.GameObjects.Text.TextStyle;

export function textStyle(size: number, color = "#000000", extra: Partial<Style> = {}): Style {
  return {
    fontFamily: FONT,
    fontSize: `${size}px`,
    color,
    resolution: TEXT_RESOLUTION,
    ...extra,
  };
}
